import axios, { AxiosResponse } from "axios";

interface ImageUploadParams {
  accessToken: string;
  method?: "post" | "put" | "patch";
  url: string;
  file: File;
  groupKey?: string;
  userId?: number;
  name?: string;
  onUploadProgress: (percentCompleted: number) => void;
}

const handleImageFiles = (
  e: React.ChangeEvent<HTMLInputElement>, 
  setter: (files: (string | ArrayBuffer | null)[]) => void
): void => {
  const files = e.target.files;
  console.log("files", files);
  if (files && files.length !== 0) {
    const imgFiles: (string | ArrayBuffer | null)[] = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const reader = new FileReader();

      reader.onload = () => {
        imgFiles[i] = reader.result;
        setter([...imgFiles]);
      };

      reader.readAsDataURL(file);
    }
  }
};

const imageUpload = async ({ 
  accessToken, 
  method = "post", 
  url, 
  file, 
  groupKey, 
  userId, 
  name, 
  onUploadProgress 
}: ImageUploadParams): Promise<AxiosResponse | undefined> => {
  const form_data = new FormData();
  if (file) form_data.append("image", file, file.name);
  else throw new Error("image file required!");

  if (groupKey) form_data.append("group_key", groupKey);
  if (userId) form_data.append("user", userId.toString());
  if (name) form_data.append("name", name);

  if (!accessToken) throw new Error("accessToken not found!");

  const myNewModel = await axios({
    method: method,
    url: url,
    data: form_data,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${accessToken}`,
    },
    onUploadProgress: (event) => {
      const percentCompleted = Math.round((event.loaded * 100) / (event.total || 1));
      onUploadProgress(percentCompleted);
    },
  })
    .then((res) => {
      return res;
    })
    .catch((error) => {
      return error.response;
    });

  // if (myNewModel.status === 201) {
  //     window.location.href = `/mymodels/${myNewModel.data.id}`;
  // }
  return myNewModel;
};

export { handleImageFiles, imageUpload };
